import { render, staticRenderFns } from "./VehicleTypesCRUD.vue?vue&type=template&id=150ec601&"
import script from "./VehicleTypesCRUD.vue?vue&type=script&lang=js&"
export * from "./VehicleTypesCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports